import { scope } from 'cssapi'
import PropTypes from 'prop-types'
import { flip, map, prop } from 'ramda'
import styled from 'styled-components'
import flexVertical from '../../styles/mixins/flexVertical'
import spaceChildrenV from '../../styles/mixins/spaceChildrenV'

const spacingMap = {
  default: `1ru`,
  none: `0`,
  small: `0.5ru`,
  large: `2ru`,
  smallInverse: `-0.5ru`,
  tiny: `0.25ru`,
}

const namedSpacingsToValues = map(flip(prop)(spacingMap))

const VLayout = styled.div`
  ${flexVertical};
  ${p =>
    spaceChildrenV(
      p.spacings
        ? namedSpacingsToValues(p.spacings)
        : scope`${spacingMap[p.spacing]}`
    )(p)};
`

VLayout.propTypes = {
  spacing: PropTypes.oneOf([
    `default`,
    `none`,
    `small`,
    `large`,
    `smallInverse`,
    `tiny`,
  ]),
}

VLayout.defaultProps = {
  spacing: `default`,
}

export default VLayout



// WEBPACK FOOTER //
// ./src/components/shared/layouts/VLayout.jsx